(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["louna-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  document.querySelectorAll('.louna-mobile-menu[open]').forEach(function(menu) {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
  });
});
document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.louna-mobile-menu[open]').forEach(function(menu) {
    menu.open = false;
    menu.querySelector('summary').focus();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
